import { Component, OnInit, ChangeDetectionStrategy, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'gen-labels-color-menu',
  templateUrl: './labels-color-menu.component.html',
  styleUrls: ['./labels-color-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LabelsColorMenuComponent implements OnInit {
  @Output() update: EventEmitter<{ cssClass: string, event: Event}> = new EventEmitter();
  public colors: string[] = [
    'tagLabelDefault',
    'tagLabelLightBlue',
    'tagLabelLightGreen',
    'tagLabelPurple',
    'tagLabelPink',
    'tagLabelOrange',
    'tagLabelRed'
  ];

  constructor() {
  }

  ngOnInit() {
  }


  updateEmit($event, value) {
    this.update.emit({ cssClass: value, event: $event});
  }
}
